import Vue from "vue";
import Vuex from "vuex";
import wizard from "./modules/wizard";
import quoteForm from "./modules/quote-form";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    wizard,
    quoteForm
  }
});
